import React from 'react';
import { ArrowLeft, PlusCircle, Calendar, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ExamenPageHeader = ({ 
  title = "Créer un Examen", 
  subtitle = "Configurez une nouvelle session d'examen",
  showBackButton = true,
  totalSessions = 0,
  totalCreneaux = 0 
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6">
      {/* Header avec gradient */}
      <div className="bg-gradient-to-r from-[#202654] via-[#202654] to-[#1a1f4a] px-6 py-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-center text-white">
            {showBackButton && (
              <button
                onClick={() => navigate(-1)}
                className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
            )}
            
            <div className="bg-white/10 p-3 rounded-xl mr-4">
              <PlusCircle className="h-8 w-8 text-white" />
            </div>
            
            <div>
              <h1 className="text-2xl font-bold">{title}</h1>
              <p className="mt-1 text-blue-100">{subtitle}</p>
            </div>
          </div>

          {/* Statistiques en temps réel */}
          {(totalSessions > 0 || totalCreneaux > 0) && (
            <div className="flex items-center space-x-4 mt-4 lg:mt-0">
              <div className="flex items-center space-x-3">
                <div className="bg-white/10 rounded-lg px-3 py-2">
                  <div className="flex items-center text-white">
                    <Calendar className="h-4 w-4 mr-2" />
                    <span className="text-sm font-medium">
                      {totalSessions} session{totalSessions > 1 ? 's' : ''}
                    </span>
                  </div>
                </div>
                
                <div className="bg-white/10 rounded-lg px-3 py-2">
                  <div className="flex items-center text-white">
                    <BookOpen className="h-4 w-4 mr-2" />
                    <span className="text-sm font-medium">
                      {totalCreneaux} créneau{totalCreneaux > 1 ? 'x' : ''}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Barre de progression */}
      <div className="bg-gray-50 px-6 py-3">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-6">
            <div className="flex items-center text-gray-600">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <span>Étape 1: Informations générales</span>
            </div>
            <div className="flex items-center text-gray-600">
              <div className={`w-2 h-2 rounded-full mr-2 ${totalSessions > 0 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
              <span>Étape 2: Sessions d'examen</span>
            </div>
            <div className="flex items-center text-gray-600">
              <div className={`w-2 h-2 rounded-full mr-2 ${totalCreneaux > 0 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
              <span>Étape 3: Créneaux horaires</span>
            </div>
          </div>
          
          <div className="text-gray-500">
            Configuration en cours...
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamenPageHeader; 